<script setup lang="ts">
// Properties
defineProps<{
    title?: string,
    text?: string,
}>();
</script>

<template>
    <button
        class="group text-base/6 text-gray-200 rounded-md px-4 py-2 font-medium cursor-pointer shrink-0 transition-colors ease-out duration-150 hover:bg-[#E2E4E9]/10 hover:text-orange-400 hover:monotone-noise active:bg-[#E2E4E9]/10 active:text-orange-400 disabled:text-gray-600"
        :title="title"
    >
        <slot>
            {{ text }}
        </slot>
    </button>
</template>

<style scoped>

</style>
